export const MENU_VIEWPORT_MARGIN = 8

export const MENU_ANCHOR_GAP = 8

export const MENU_MAX_WIDTH = 320

export const MENU_MAX_HEIGHT = 360

export const MENU_MIN_HEIGHT = 140

export type AnchorRect = {
  top: number
  bottom: number
  left: number
  right: number
}

export type Viewport = {
  width: number
  height: number
}

export type DevicePlacement = {
  left: number
  width: number
  maxHeight: number
  top?: number
  bottom?: number
}

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max)

export const getDevicePlacement = (anchor: AnchorRect, viewport: Viewport): DevicePlacement => {
  const width = Math.max(Math.min(MENU_MAX_WIDTH, viewport.width - 2 * MENU_VIEWPORT_MARGIN), 0)

  const left = clamp(
    (anchor.left + anchor.right) / 2 - width / 2,
    MENU_VIEWPORT_MARGIN,
    Math.max(viewport.width - MENU_VIEWPORT_MARGIN - width, MENU_VIEWPORT_MARGIN)
  )

  const above = anchor.top - MENU_ANCHOR_GAP - MENU_VIEWPORT_MARGIN
  const below = viewport.height - anchor.bottom - MENU_ANCHOR_GAP - MENU_VIEWPORT_MARGIN

  if (Math.max(above, below) < MENU_MIN_HEIGHT) {
    return {
      left,
      width,
      top: MENU_VIEWPORT_MARGIN,
      maxHeight: Math.max(viewport.height - 2 * MENU_VIEWPORT_MARGIN, 0)
    }
  }

  return below < MENU_MIN_HEIGHT && above > below
    ? {
        left,
        width,
        bottom: viewport.height - anchor.top + MENU_ANCHOR_GAP,
        maxHeight: Math.min(above, MENU_MAX_HEIGHT)
      }
    : {
        left,
        width,
        top: anchor.bottom + MENU_ANCHOR_GAP,
        maxHeight: Math.min(below, MENU_MAX_HEIGHT)
      }
}
